<template>
  <v-row class="pa-2 fill-height" justify="space-between" align="stretch">
    <v-col cols="12" class="pb-0">
      <v-row justify="space-between" align="stretch" no-gutters class="px-2">
        <v-col cols="12"> <h3 class="mb-2">Orders Overview</h3> </v-col>
      </v-row>
      <v-row justify="space-between" align="stretch" no-gutters class="px-2">
        <v-col cols="6" md="4">
          <v-dialog ref="dialog" v-model="fromDialog" persistent width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                v-model="fromText"
                label="From Date"
                prepend-icon="mdi-calendar"
                readonly
              ></v-text-field>
            </template>

            <v-date-picker
              v-model="fromDate"
              no-title
              v-on:change="(fromDialog = false), getOrders()"
            >
              <v-spacer></v-spacer>
              <v-btn text color="blue darken-2" @click="fromDialog = false"
                >Cancel</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col cols="6" md="4">
          <v-dialog ref="dialog" v-model="toDialog" persistent width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                v-model="toText"
                label="To Date"
                prepend-icon="mdi-calendar"
                readonly
              ></v-text-field>
            </template>

            <v-date-picker
              v-model="toDate"
              no-title
              v-on:change="(toDialog = false), getOrders()"
            >
              <v-spacer></v-spacer>
              <v-btn text color="blue darken-2" @click="toDialog = false"
                >Cancel</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="blue darken-2"
        show-arrows
      >
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in items" :key="item">
          <v-data-table
            :headers="headers"
            :items="orders[tab + 1]"
            disable-pagination
            class="elevation-0"
            :loading="loading"
            loading-text="Loading... Please wait"
            :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template slot="progress">
              <v-progress-linear
                color="blue darken-2"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:[`item.invoice_date`]="{ item }">
              <span>{{ formatTableDate(item.invoice_date) }}</span>
            </template>
            <template v-slot:[`item.transaction_date`]="{ item }">
              <span>{{ formatTableDate(item.transaction_date) }}</span>
            </template>

            <template v-slot:[`item.grand_total`]="{ item }">
              <span>£{{ parseFloat(item.grand_total).toFixed(2) }}</span>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import axios from "@/axios";

// -- Status from CP below
// const ACTIVEORDER_ENTERED = 1;
// const ACTIVEORDER_PICKED = 2;
// const ACTIVEORDER_DISPATCHED = 3;
// const ACTIVEORDER_CONFIRMED = 4;
// const ACTIVEORDER_INVOICED = 5;
// const ACTIVEORDER_PAID = 6;
// const ACTIVEORDER_INVISIBLE = 9;

export default {
  name: "OrdersOverview",

  props: {},

  data() {
    return {
      loading: false,
      tab: 0,

      fromDialog: false,
      toDialog: false,

      fromDate: moment(this.getDate(28)).format("YYYY-MM-DD"),
      toDate: moment(this.getDate(0)).format("YYYY-MM-DD"),

      items: ["Entered", "Picked", "Dispatched", "Confirmed", "Invoiced"],

      orders: {},

      headers: [
        { text: "Ticket #", value: "invoice_no" },
        { text: "Customer", value: "customer_name", sortable: false },
        { text: "Cust Ref", value: "cust_po_ref", sortable: false },
        { text: "Distributor", value: "distributor_name", sortable: false },
        {
          text: "Dist Ref",
          value: "distributor_transaction_ref",
          sortable: false,
        },
        { text: "Created", value: "invoice_date", sortable: false },
        {
          text: "Transaction Date",
          value: "transaction_date",
          sortable: false,
        },
        { text: "Total", value: "grand_total", sortable: false },
      ],
    };
  },

  async beforeMount() {
    this.getOrders();
  },

  computed: {
    fromText() {
      return this.fromDate ? moment(this.fromDate).format("Do MMM  YY") : "";
    },

    toText() {
      return this.toDate ? moment(this.toDate).format("Do MMM  YY") : "";
    },

    trolly() {
      return this.$store.getters.retrieveCurrentTrolly;
    },
  },

  methods: {
    formatTableDate(date) {
      return date ? moment(date).format("Do MMM  YY") : "";
    },

    getDate(daysPast = 0) {
      let today = new Date();
      today.setDate(today.getDate() - daysPast);

      return today;
    },

    async getOrders() {
      this.loading = true;

      let payload = {
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        dates: [this.fromDate, this.toDate],
      };

      console.log("-- Checking Unpaid");
      console.log(payload);
      let stringPayload = JSON.stringify(payload);
      const params = new URLSearchParams();
      params.append("params", stringPayload);

      const response = await axios.post("order/get-orders-overview", params);

      this.loading = false;

      if (response.data.success == true) {
        this.orders = response.data.orders;
        return response.data.success;
      } else {
        response.data.success;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>